module.exports = __webpack_public_path__ + "static/media/vinted-copy.9d1d889f.png";